// ===========================================
// Dashboard Page - Redirects to role-specific dashboard
// ===========================================

import { Navigate, useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../contexts/useAuth';
import { getDashboardPath } from '../utils/routing';

export default function DashboardPage() {
  const { user, isLoading } = useAuth();
  const { schoolSlug } = useParams<{ schoolSlug: string }>();
  const effectiveSlug = schoolSlug || 'music-n-me';

  // Show loading while checking auth
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to login if no user
  if (!user) {
    return <Navigate to={`/${effectiveSlug}/login`} replace />;
  }

  // Redirect to role-specific dashboard
  return <Navigate to={getDashboardPath(user.role, effectiveSlug, { isStaff: user.isStaff })} replace />;
}
